import { render, staticRenderFns } from "./BillSubTable.vue?vue&type=template&id=d1b20fd4&scoped=true&"
import script from "./BillSubTable.vue?vue&type=script&lang=ts&"
export * from "./BillSubTable.vue?vue&type=script&lang=ts&"
import style0 from "./BillSubTable.vue?vue&type=style&index=0&id=d1b20fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b20fd4",
  null
  
)

export default component.exports